import { Outlet } from "react-router-dom";
import Sidebar from "../components/sidebar";
import Header from "../components/header";

const MainLayout = () => {
  return (
    <div className="layout-container">
      <Sidebar />
      <div className="main-content">
        <Header />
        <section className="content-wrapper">
          <div className="container-fluid px-0 px-lg-4">
            <div className="row justify-content-center m-0"><Outlet/></div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default MainLayout;
